export default {
  nav: {
    play: 'Play',
    about: 'About',
    features: 'Features',
    tips: 'Tips',
    faq: 'FAQ'
  },
  hero: {
    title: 'Monster Survivors',
    subtitle: 'The Ultimate Free Online Roguelike Survival Game',
    playButton: 'Play Now',
    learnButton: 'Learn More'
  },
  about: {
    title: 'About Monster Survivors',
    description1: 'Monster Survivors is an exciting roguelike survival game where you battle endless waves of monsters.',
    description2: 'Choose your character, upgrade your abilities, and see how long you can survive!',
    description3: 'With unique weapon combinations and character progression, every playthrough is different.',
    description4: 'Free to play directly in your browser - no download required!'
  },
  features: {
    title: 'Game Features',
    characters: {
      title: 'Unique Characters',
      description: 'Choose from multiple characters, each with their own special abilities and playstyles.'
    },
    weapons: {
      title: 'Weapon Evolution',
      description: 'Combine different weapons and items to create powerful evolved versions.'
    },
    gameplay: {
      title: 'Endless Action',
      description: 'Face increasingly difficult waves of monsters in procedurally generated levels.'
    }
  },
  tips: {
    title: 'Gameplay Tips',
    tip1: {
      title: 'Master Movement',
      description: 'Stay mobile and learn to kite enemies while attacking.'
    },
    tip2: {
      title: 'Plan Your Build',
      description: 'Choose upgrades that complement your character and playstyle.'
    },
    tip3: {
      title: 'Level Up Fast',
      description: 'Collect experience gems quickly to stay ahead of the difficulty curve.'
    }
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: {
      question: 'Is Monster Survivors free to play?',
      answer: 'Yes, Monster Survivors is completely free to play in your web browser. No download or installation required!'
    },
    q2: {
      question: 'How do I play Monster Survivors?',
      answer: 'Use WASD to move, Space to attack, and E for special abilities. Collect experience to level up and choose upgrades to become stronger!'
    },
    q3: {
      question: 'What makes Monster Survivors unique?',
      answer: 'Monster Survivors features unique character progression, weapon evolution system, and procedurally generated levels. Each playthrough offers a different experience!'
    }
  },
  newsletter: {
    title: 'Stay Updated',
    description: 'Subscribe to our newsletter for updates, tips, and special events!',
    placeholder: 'Enter your email',
    button: 'Subscribe'
  },
  related: {
    title: 'Similar Games You Might Like',
    description: 'Check out these other great roguelike survival games!'
  },
  footer: {
    quickLinks: 'Quick Links',
    social: 'Follow Us',
    copyright: '© 2024 Monster Survivors. All rights reserved.'
  },
  reviews: {
    title: 'Game Reviews',
    rating: 'Rating',
    commentPlaceholder: 'Share your gaming experience...',
    submit: 'Submit Review',
    ratingRequired: 'Please select a rating',
    commentRequired: 'Please enter your review',
    commentTooLong: 'Review cannot exceed 500 characters',
    invalidRating: 'Rating must be between 1 and 5',
    submitSuccess: 'Review submitted successfully! Thank you for your feedback!',
    noReviews: 'No reviews yet. Be the first to share your thoughts!'
  },
  time: {
    justNow: 'Just now',
    minutesAgo: '{minutes} minutes ago',
    hoursAgo: '{hours} hours ago',
    daysAgo: '{days} days ago'
  },
  errors: {
    firebaseNotInitialized: 'Failed to initialize Firebase',
    permissionDenied: 'Permission denied. Please try again later.',
    rateLimitExceeded: 'Too many reviews submitted. Please wait a moment.',
    submitFailed: 'Failed to submit review: {message}',
    loadFailed: 'Failed to load reviews. Please try again later.',
    tryAgainLater: 'Please try again later'
  }
} 